// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"Breadcrumbs_wrapper__d_Y0c","breadcrumbs":"Breadcrumbs_breadcrumbs__25Iuz","breadcrumb":"Breadcrumbs_breadcrumb__YRNgz","angle":"Breadcrumbs_angle__FxnDh"};